import { Injectable } from "@angular/core";
import { CircuitElementState, MuxElement } from "../../diagram/models/diagram.models";
import { DwdmDiagramConverterHelper } from "./dwdm-diagram-converter-helper";
import { MuxConverterData } from "./dwdm-diagram-converter.models";
import { MuxDemuxData } from "../../wizard/steps/1-ends/end-step-circuit-dwdm.model";

/**
 * Responsável por converter @see MuxConverterData em @see MuxElement.
 */
@Injectable({
    providedIn: "root"
})
export class DwdmDiagramConverterMuxService {

    public convert(muxData: MuxConverterData): MuxElement | null {
        if (this.isMuxEnabled(muxData)) {
            const muxState = this.isMuxSelected(muxData) ? CircuitElementState.CONFIGURED : CircuitElementState.NOT_CONFIGURED;
            return this.createMux(muxState);
        }

        return null;
    }

    private createMux(state: CircuitElementState): MuxElement {
        return {
            id: DwdmDiagramConverterHelper.createId(),
            state
        };
    }

    /**
     * Indica se o campo checkbox do Mux foi habilitado.
     * Não necessariamento o Mux já foi selecionado.
     * Nesse caso, o elemento Mux será criado na cor azul clara.
     */
    private isMuxEnabled(muxData: MuxConverterData): boolean {
        return muxData.hasMux;
    }

    /**
     * Indica se o Mux foi selecionado.
     * Nesse caso, o elemento Mux será criado na cor azul escuro.
     */
    private isMuxSelected(muxData: MuxConverterData): MuxDemuxData {
        return muxData.mux;
    }
}
